var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.421,
    height: 20.113,
    viewBox: "0 0 18.421 20.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49792",
    "data-name": "Group 49792",
    transform: "translate(-1466 -89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138325",
    "data-name": "Rectangle 138325",
    width: 16.92,
    height: 16.921,
    rx: 3.636,
    transform: "translate(1466.75 91.442)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_605",
    "data-name": "Line 605",
    y2: 3.384,
    transform: "translate(1470.98 89.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_606",
    "data-name": "Line 606",
    y2: 3.384,
    transform: "translate(1479.441 89.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_607",
    "data-name": "Line 607",
    x2: 16.921,
    transform: "translate(1466.75 96.518)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.88c13fc70fc6c146648571fb406975d2.svg";
export { ForwardRef as ReactComponent };